import { FiChevronLeft } from '@react-icons/all-files/fi/FiChevronLeft';
import { FiChevronRight } from '@react-icons/all-files/fi/FiChevronRight';
import React, { useMemo } from 'react';
import Slider from 'react-slick';
import { BREAKPOINT_CONFIG } from '~view/contexts/breakpoint';
import './styles.scss';

const HorizontalSlider: React.FC<{
  xl?: number;
  lg?: number;
  md?: number;
  sm?: number;
  xs?: number;
  contentAlign?: 'center' | 'left' | 'right';
}> = ({ xl, lg, md, sm, xs, contentAlign = 'left', children }) => {
  const childCount = React.Children.count(children);
  const settings = useMemo(
    () => ({
      infinite: childCount > (xl ?? 5),
      speed: 500,
      slidesToShow: xl ?? 5,
      slidesToScroll: xl ?? 5,
      initialSlide: 0,
      nextArrow: <FiChevronRight color="black" size={20} />,
      prevArrow: <FiChevronLeft color="black" size={20} />,
      responsive: [
        {
          breakpoint: BREAKPOINT_CONFIG.xl,
          settings: {
            infinite: childCount > (lg ?? 4),
            slidesToShow: lg ?? 4,
            slidesToScroll: lg ?? 4,
          },
        },
        {
          breakpoint: BREAKPOINT_CONFIG.lg,
          settings: {
            infinite: childCount > (md ?? 3),
            slidesToShow: md ?? 3,
            slidesToScroll: md ?? 3,
          },
        },
        {
          breakpoint: BREAKPOINT_CONFIG.md,
          settings: {
            infinite: false,
            slidesToShow: sm ?? 2,
            slidesToScroll: sm ?? 2,
          },
        },
        {
          breakpoint: BREAKPOINT_CONFIG.sm,
          settings: {
            infinite: false,
            slidesToShow: xs ?? 2,
            slidesToScroll: xs ?? 2,
          },
        },
      ],
    }),
    [xl, lg, md, sm, xs, childCount]
  );
  return (
    <Slider
      className={`horizontal-slider ${
        contentAlign === 'left'
          ? 'slider-left'
          : contentAlign === 'right'
          ? 'slider-right'
          : ''
      }`}
      {...settings}
    >
      {children}
    </Slider>
  );
};

export default HorizontalSlider;
